import {
  classNames,
  conditionalValuesToCSSVars,
  cloneChildrenWithAttributes
} from "../uitk-react-utils/index.js";
import { breakpoints } from "../egencia-provider/shared-ui-providers/viewport-context/viewport-context.js";
const spacingPixels = 4;
const spacingKeyMap = {
  zero: `0px`,
  half: `${0.5 * spacingPixels}px`,
  one: `${spacingPixels}px`,
  two: `${2 * spacingPixels}px`,
  three: `${3 * spacingPixels}px`,
  four: `${4 * spacingPixels}px`,
  six: `${6 * spacingPixels}px`,
  ten: `${10 * spacingPixels}px`,
  twelve: `${12 * spacingPixels}px`
};
export function fillBreakpointProps(props) {
  const newProps = {};
  for (const spacing of ["margin", "padding"]) {
    for (let breakPointIndex = 0; breakPointIndex < breakpoints.length; breakPointIndex++) {
      for (const direction of ["inline", "block"]) {
        for (const alignment of ["start", "end"]) {
          const prop = `${direction}${alignment}`;
          let value;
          let currentBreakPointIndex = breakPointIndex;
          while (value === void 0 && currentBreakPointIndex >= 0) {
            const breakpoint2 = breakpoints[currentBreakPointIndex];
            if (typeof props[spacing]?.[breakpoint2]?.[prop] === "string") {
              value = props[spacing]?.[breakpoint2]?.[prop];
            } else if (typeof props[spacing]?.[breakpoint2]?.[direction] === "string") {
              value = props[spacing]?.[breakpoint2]?.[direction];
            } else if (typeof props[spacing]?.[breakpoint2] === "string") {
              value = props[spacing]?.[breakpoint2];
            } else if (typeof props[spacing]?.[prop] === "string") {
              value = props[spacing]?.[prop];
            } else if (typeof props[spacing]?.[direction] === "string") {
              value = props[spacing]?.[direction];
            } else if (typeof props[spacing] === "string") {
              value = props[spacing];
            }
            currentBreakPointIndex--;
          }
          if (typeof value === "string" && value !== "unset") {
            value = spacingKeyMap[value];
          }
          if (value === void 0)
            continue;
          const breakpoint = breakpoints[breakPointIndex];
          if (!newProps[spacing]) {
            newProps[spacing] = {};
          }
          if (!newProps[spacing][breakpoint]) {
            newProps[spacing][breakpoint] = {};
          }
          const cssProp = `${direction}-${alignment}`;
          newProps[spacing][breakpoint][cssProp] = value;
        }
      }
    }
  }
  if (props.border) {
    for (const direction of ["inline", "block"]) {
      for (const alignment of ["start", "end"]) {
        for (let breakPointIndex = 0; breakPointIndex < breakpoints.length; breakPointIndex++) {
          const prop = `${direction}${alignment}`;
          let value;
          let currentBreakPointIndex = breakPointIndex;
          while (value === void 0 && currentBreakPointIndex >= 0) {
            const breakpoint2 = breakpoints[currentBreakPointIndex];
            if (Array.isArray(props.border[breakpoint2]) && props.border[breakpoint2]?.includes(prop)) {
              value = "1px";
            } else if (Array.isArray(props.border[breakpoint2]) && props.border[breakpoint2]?.includes(direction)) {
              value = "1px";
            } else if (Array.isArray(props.border) && props.border.includes(prop)) {
              value = "1px";
            } else if (Array.isArray(props.border) && props.border.includes(direction)) {
              value = "1px";
            }
            currentBreakPointIndex--;
          }
          if (value === void 0)
            continue;
          const breakpoint = breakpoints[breakPointIndex];
          if (!newProps["border"]) {
            newProps["border"] = {};
          }
          if (!newProps["border"][breakpoint]) {
            newProps["border"][breakpoint] = {};
          }
          const cssProp = `${direction}-${alignment}`;
          newProps["border"][breakpoint][cssProp] = value;
        }
      }
    }
  }
  return newProps;
}
export function UitkSpacing(props) {
  const newProps = fillBreakpointProps(props);
  const style = {
    ...conditionalValuesToCSSVars(
      newProps.margin,
      "margin"
    ),
    ...conditionalValuesToCSSVars(
      newProps.padding,
      "padding"
    ),
    ...conditionalValuesToCSSVars(
      newProps.border,
      "border"
    ),
    ...props.style
  };
  const className = classNames(
    "uitk-spacing",
    props.className
  );
  return cloneChildrenWithAttributes(props.children, {
    className,
    style,
    otherProps: {
      "data-stid": props.stid
    }
  });
}
